// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"edb72709","262":"8e728182","453":"dab362cc","626":"22cd95f3"}[chunkId] + ".chunk.js";
};